import { mapGetters }           from "vuex";
import { 
  formatDateTime, 
  stringHelper,
  sizeHelper,
}                               from "@/components/mixins";
import { ShoppingCartService }  from "@/services/ShoppingCartService"
import { PartListService }      from "@/services/PartListService"
import { ErrorLogService, PartDetailServices } from "@/services";
import { ObjectUtil } from "@/services";

// icons
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { PartValidationReason, IPartListItemDto } from "@/types";


export const partInfoHelper = {
  mixins: [formatDateTime, stringHelper, sizeHelper],
  computed: {
    ...mapGetters([
      "user",
      "getContentItem",
      "availableDealerCodes",
      "activeAccountId",
      "hasPermission",
      "IsMcfa",
      "IsMcfe",
      "IsMcfs",
      "tenantDetails",
      "partsLists",
      "cartSummary",
      "isPriceVisible",
      "collapseAllPartDescriptionsValue"
    ]),
    OemPartCode() {
      if (this.IsNotNullOrUndefined(this.part, 'OemPartCode')) {
        return this.part.OemPartCode;
      } else {
        return this.part.OriginalOemPartCode;
      }
    },
    RequiresQuote() {
      if (this.IsNotNullOrUndefined(this.part, 'FullPartDetails')) {
        return this.part.FullPartDetails.PartNullForUserCostCenter;
      } else {
        return false;
      }
    },
    IsSpecialOrder() {
      return this.IsNotNullOrUndefined(this.part, 'FullPartDetails.IsSpecialOrder') && this.part.FullPartDetails.IsSpecialOrder === true;
    },
    IsDropShipped() {
      return this.IsNotNullOrUndefined(this.part, 'FullPartDetails.IsDropShip') && this.part.FullPartDetails.IsDropShip === true;
    },
    HasVendorStock() {
      return this.IsNotNullOrUndefined(this.part, 'FullPartDetails.ExternalStockQuantities') && this.part.FullPartDetails.HasVendorStock;
    },
    isSuperseded(){
      return (this.IsNotNullOrUndefined(this.part, 'FullPartDetails.Validation.ReplacementPartsCount') && (this.part.FullPartDetails?.Validation?.ReplacementPartsCount > 0) 
              || (this.IsNotNullOrUndefined(this.part, 'FullPartDetails.Validation.ReplacementPartId') && this.part.FullPartDetails?.Validation?.ReplacementPartId > 0));
    },
    ShowFleetPrice() {
      return this.hasPermission('CanSeeFleetList')
        && this.part.FullPartDetails.FleetListPrice != 0
        && this.isPriceVisible;
    },
    ShowDealerNetPrice() {
      return this.hasPermission('CanSeeDealerNet')
        && this.IsNotNullOrUndefined(this.part, 'FullPartDetails')
        && this.part.FullPartDetails.DealerNetPrice != 0
        && this.part.FullPartDetails.DealerNetPrice >= this.part.FullPartDetails.ContractPrice
        && this.isPriceVisible;
    },
    ShowContractPrice() {
      return this.hasPermission('CanSeeContractPrice')
        && this.part.FullPartDetails.ContractPrice != 0
        && this.part.FullPartDetails.DealerNetPrice !== this.part.FullPartDetails.ContractPrice
        && this.isPriceVisible;
    },
    showDekaCoreDoc(){
      return ['L01', 'L10'].includes(this.part.FullPartDetails.PicCode);
    },
  },
  data: () => ({
    showAddToPartListSection: false,
    currentlyAddingPartToCart: false,
    currentlyAddingPartToPartList: false,
    createNewPartListName: "",
    selectedPartList: null,
    addToCartQuantity: 0,
    requestingQuote: false,
    collapsePartDescription: false,
    previousCollapseAllValue: false,
    downChevronIcon: faChevronDown,
    upChevronIcon: faChevronUp,
    truncatedDescription: "",
    truncatedDescriptionLength: 40,
  }),
  props: {
    part: {},
    partImageOverride: String,
    partIdOverride: {
      type: Number,
      default: 0
    },
    isCross: {
      type: Boolean,
      default: false
    },
    isTms: {
      type: Boolean,
      default: false
    }
  },
  created(){
    this.collapsePartDescription = this.collapseAllPartDescriptionsValue;
    this.previousCollapseAllValue = this.collapseAllPartDescriptionsValue;
  },
  methods: {
    showAddToCart(part: any) {

      if (this.hasPermission("CanPlaceOrders")) {
        return true;
      }
      return false;
    },
    partHasAPrice(part: any) {
      if (this.IsNullOrUndefined(part, "FullPartDetails")) {
        return false;
      }
      if (part.FullPartDetails.DealerNetPrice > 0 || part.FullPartDetails.ContractPrice > 0) {
        return true;
      }
      return false;
    },
    GetCalculatedDealerNetPrice(part: any){
      if( this.IsNotNullOrUndefined(part.FullPartDetails)){
        var contractPrice = part.FullPartDetails.ContractPrice;
        var dealerNetPrice = part.FullPartDetails.DealerNetPrice;
        if( this.IsNotNullOrUndefined(contractPrice) && contractPrice != dealerNetPrice && contractPrice != 0){
          return contractPrice;
        }else{
          return dealerNetPrice;
        }
      }
    },
    showMainWarehouseStockTemplate(part: any){
      let hasWarehouseStock = false;
      if( this.IsMcfe ){
          hasWarehouseStock = part.FullPartDetails.WarehouseStockQuantities.some((x: any) => x.WarehouseCode === 'BE')
      }else if( this.IsMcfs){
          hasWarehouseStock = part.FullPartDetails.WarehouseStockQuantities.some((x: any) => x.WarehouseCode === 'SI')
      }else{
          return false;
      }

      return hasWarehouseStock;
    },
    warehouseStockQuantities(part: any){
      if( this.IsMcfe){
          return part.FullPartDetails.WarehouseStockQuantities.filter((x: any) => x.WarehouseCode === 'BE')
      } else if(this.IsMcfs){
          return part.FullPartDetails.WarehouseStockQuantities.filter((x: any) => x.WarehouseCode === 'SI')
      } else{
          return part.FullPartDetails.WarehouseStockQuantities;
      }          
    },
    otherWarehouses(part: any){
      let otherWarehouses = [];
      if( this.IsMcfe ){
          otherWarehouses = part.FullPartDetails.WarehouseStockQuantities.filter((x: any) => x.WarehouseCode !== 'BE')
      }else if( this.IsMcfs){
          otherWarehouses = part.FullPartDetails.WarehouseStockQuantities.filter((x: any) => x.WarehouseCode !== 'SI')
      }else{
          return [];
      }
      
      return otherWarehouses;
    },
    allowedToSeePartPrices(part: any) {
      if (this.IsNullOrUndefined(part, "FullPartDetails")) {
        return false;
      }
      if (part.FullPartDetails.DealerNetPrice > 0 && this.hasPermission("CanSeeDealerNet")) {
        return true;
      }
      if (part.FullPartDetails.ContractPrice > 0 && this.hasPermission("CanSeeContractPrice")) {
        return true;
      }
      return false;
    },
    
    showPrices(part) {
      if( !this.isPriceVisible )
      {
          return false
      }
      var partValidationReason = part.FullPartDetails.Validation.ValidationReason;

      // Dealer support would like pricing hidden on controller parts that are on soft freeze. 
      // The parts have a DealerNet price but by time they are programmed they actually are much more expensive. 
      if (this.IsMcfa &&
        partValidationReason === PartValidationReason.IsSoftFrozen &&
        part.FullPartDetails.PicCode === "608") {
          return false;
      }
      // We want to hide pricing if channel not authorized (mostly due but missed bulk pricing on part detail main page and the part alternatives display).
      // We also want to hide canceled, superseded and discontinued part's prices.
      const invalidReasons = [
          PartValidationReason.IsChannelNotAuthorized,
          PartValidationReason.IsCanceled,
          PartValidationReason.IsSuperseded,
          PartValidationReason.IsDiscontinued,
          PartValidationReason.ItemNotPriced,
          PartValidationReason.IsMaoNoPrice,
          PartValidationReason.IsProhibited,
          PartValidationReason.IsHardFrozen,
          PartValidationReason.IsMaoLimitExceededPriceNotCurrentNoStockQuantity,
          PartValidationReason.IsMaoLimitExceededPriceNotCurrent,
          PartValidationReason.MaoSoftFrozen
      ]
      if (invalidReasons.includes(partValidationReason)) {
          return false;
      }
      return true;
    },
    
    resetPartListData() {
      this.createNewPartListName = "";
      this.selectedPartList = null;
    },
    toggleAddToPartListSection() {
      this.$store.dispatch("LOAD_PARTS_LISTS")
      this.showAddToPartListSection = !this.showAddToPartListSection;
    },
    addToCart() {
      let qty = this.addToCartQuantity;
      if(!this.IsNullOrUndefined(this.part.FullPartDetails.MinimumOrderQuantity)){
        qty = qty < this.part.FullPartDetails.MinimumOrderQuantity ? this.part.FullPartDetails.MinimumOrderQuantity : qty;
      }
      this.currentlyAddingPartToCart = true;

      let partId = this.part.FullPartDetails.Id;
      if (this.partIdOverride > 0) {
        partId = this.partIdOverride;
      }

      var params = {
        shoppingCartId: this.cartSummary.Id,
        partId: partId,
        quantity: qty,
        accountId: this.activeAccountId,
        userId: this.user.UserId
      }

      let oemPartCode = this.part.OemPartCode ??  this.part.OriginalOemPartCode;
      ShoppingCartService.AddShoppingCartItem(params).then(result => {
        this.$store.dispatch("LOAD_CART_SUMMARY", { accountId: this.activeAccountId, userId: this.user.UserId });
        this.$store.commit("pushTimedMessage", {
          header: `Item ${oemPartCode} added to cart successfully`,
          IsError: false,
          seconds: 5
        });
      })
        .catch(() => {
          this.$store.commit("pushTimedMessage", {
            header: `Error adding ${oemPartCode} to cart`,
            IsError: true,
            seconds: 5
          })
        })
        .finally(() => {
          this.currentlyAddingPartToCart = false;
        });
    },

    async getReplacementItems(){
      const validation = this.part.FullPartDetails.Validation;
      const replacements = [];

      // Single replacement item - fetch directly by ReplacementPartId
      if (validation.ReplacementPartId > 0) {
        const params = {
          oemPartCode: null,
          partId: validation.ReplacementPartId,
          accountId: this.activeAccountId,
          userId: this.user.UserId,
          audienceIds: this.audienceIds,
        };

        const partDetail = await PartDetailServices.getPartDetail(params);
        if (partDetail) {
          replacements.push({
            FullPartDetails: partDetail,
            OemPartCode: partDetail.OemPartCode,
            Quantity: validation.ReplacementPartQuantity ?? 1,
          });
        }
        return replacements;
      }

      // Multiple replacement items
      const requestParams = {
        accountId: this.activeAccountId,
        userId: this.user.UserId,
        partId: this.part.FullPartDetails.Id,
        oemPartCode: this.part.FullPartDetails.OemPartCode,
      };

      const results = await PartDetailServices.getReplacementItems(requestParams);

      if (results != null && results.length > 0) {
        const partPromises = results.map(async (item: any) => {
          const params = {
            oemPartCode: item.ReplacementOemPartCode,
            partId: null,
            accountId: this.activeAccountId,
            userId: this.user.UserId,
            audienceIds: this.audienceIds,
          };

          const partDetail = await PartDetailServices.getPartDetail(params);
          return { FullPartDetails: partDetail, OemPartCode: item.ReplacementOemPartCode, Quantity: item.ReplacementPartQuantity ?? 0 };
        });

        const parts = await Promise.all(partPromises);
        replacements.push(...parts);
      }

      return replacements;
    },

    addPartToPartList(part: any, overridePartListId = "") {
      this.currentlyAddingPartToPartList = true;
      let qty = this.addToCartQuantity;
      let partListId = ""
      if (overridePartListId !== "") {
        partListId = overridePartListId;
      } else {
        partListId = this.selectedPartList.Id
      }
      part.Quantity = qty;

      var item;
      if (this.isCross === true) {
        item = ObjectUtil.createInstance<IPartListItemDto>({
          Id: part.CrossPartId,
          OemPartCode: part.OriginalOemPartCode,
          Quantity: part.Quantity,
        });
      }
      else {

        item = ObjectUtil.createInstance<IPartListItemDto>({
          Id: part.PartId,
          OemPartCode: part.OemPartCode,
          Quantity: part.Quantity,
        });
      }

      let request = {
        accountId: this.activeAccountId,
        userId: this.user.UserId,
        partListId: Number(partListId),
        dealerCode: this.user.DealerCode,
        partListItems: [item]
      };

      PartListService.AddPartListItems(request).then(response => {
        this.$store.commit("pushTimedMessage", {
          header: "Successfully added items to part list",
          IsError: false,
          seconds: 15
        });
      }).catch(err => {
        this.$store.commit("pushTimedMessage", {
          header: "Error adding to part list",
          IsError: true,
          seconds: 15
        });
      }).finally(() => {
        this.currentlyAddingPartToPartList = false;
        this.showAddToPartListSection = false;
      });
    },
    getPartValidationMessageHtml(messageKey: string) {
      if (["IsSoftFrozenLong", "IsMaoLimitExceededLong", "ThisIsAnInvalidPartButThereIsOneOrMoreCrossReferences", "ThisItemHasBeenDiscontinuedCall"].includes(messageKey)) {
        return this.format(this.getContentItem(messageKey), this.tenantDetails.SupportPhoneNumber);
      }
      if (["CanceledLong4"].includes(messageKey)) {
        return this.format(this.getContentItem(messageKey), this.getContentItem("dealerSupport"), this.tenantDetails.SupportPhoneNumber);
      }
      if (this.IsNullOrUndefined(messageKey)) {
        return this.getContentItem("CrossMessage1");
      }

      return this.getContentItem(messageKey);
    },
    clickedPartListAddButton() {
      if (this.createNewPartListName === "" && this.selectedPartList === null) {
        alert("Please choose an existing part list, or enter a name for a name part list.")
        return;
      }
      this.currentlyAddingPartToList = true;
      if (this.createNewPartListName !== "") {
        let params = {
          accountId: this.user.PrimaryAccountId,
          userId: this.user.UserId,
          partListName: this.createNewPartListName
        };

        PartListService.CreateNewPartList(params).then(createPartListResponse => {
          this.$store.dispatch("LOAD_PARTS_LISTS");
          this.addPartToPartList(this.part, createPartListResponse.Id);
          this.$store.commit("pushTimedMessage", {
            header: "Successfully created new part list",
            IsError: false,
            seconds: 15
          });

        }).catch(err => {
          this.$store.commit("pushTimedMessage", {
            header: "Error creating new part list",
            IsError: true,
            seconds: 15
          });
          this.currentlyAddingPartToList = false
        });
      } else {
        this.addPartToPartList(this.part);
      }

      this.resetPartListData()
    },
    toggleRequestQuote() {
      this.requestingQuote = !this.requestingQuote;
    },
    quoteSubmitted() {
      this.requestingQuote = false;
    },
  },
  watch: {
  },
}
